import React, { useState } from 'react';

import Loading from '@common/components/Loading/Loading';

import CraftEditor from './components/CraftEditor';
import EditorHeader from './components/EditorHeader';

import styles from './TemplateEditor.module.scss';
import TedTheme from '@common/providers/ThemeProvider/TedTheme';

import useCurrentLanguageEditorState from '@hooks/useCurrentLanguageEditorState';

const TemplateEditor = () => {
  const { currentLanguageEditorState, currentLanguage, source } =
    useCurrentLanguageEditorState();

  const [saveLoading, setSaveLoading] = useState(false);

  return source?.structure ? (
    <>
      <div className={styles.top}>
        <div className={styles.title}>
          <TedTheme>
            <EditorHeader />
          </TedTheme>
        </div>
      </div>

      {saveLoading && <Loading />}
      <CraftEditor
        key={currentLanguageEditorState?.language}
        jsonData={currentLanguageEditorState?.jsonData}
        setSaveLoading={setSaveLoading}
        templateSubject={currentLanguageEditorState?.subject}
        currentLanguage={currentLanguage}
      />
    </>
  ) : (
    <Loading />
  );
};

export default TemplateEditor;
